"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("./skillBar.scss");
var SkillsBar = /** @class */ (function (_super) {
    __extends(SkillsBar, _super);
    function SkillsBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SkillsBar.prototype.render = function () {
        return (react_1.default.createElement("div", { className: 'b-backend-container', "data-aos": "zoom-out" },
            react_1.default.createElement("div", { className: 'backend-card ' },
                react_1.default.createElement("span", null, "N"),
                react_1.default.createElement("div", { className: 'img-container-desc', id: 'node_logo' },
                    react_1.default.createElement("a", { href: 'https://nodejs.org/en/', target: '_blank' }, "Node.js\u00AE"))),
            react_1.default.createElement("div", { className: 'backend-card' },
                react_1.default.createElement("span", null, "R"),
                react_1.default.createElement("div", { className: 'img-container-desc', id: 'react_logo' },
                    react_1.default.createElement("a", { href: 'https://reactjs.org/', target: '_blank' }, "React.js\u00AE"))),
            react_1.default.createElement("div", { className: 'backend-card' },
                react_1.default.createElement("span", null, "E"),
                react_1.default.createElement("div", { className: 'img-container-desc', id: 'express_logo' },
                    react_1.default.createElement("a", { href: 'https://expressjs.com/', target: '_blank' }, "Express.js\u00AE"))),
            react_1.default.createElement("div", { className: 'backend-card' },
                react_1.default.createElement("span", null, "M"),
                react_1.default.createElement("div", { className: 'img-container-desc', id: 'mongo_logo' },
                    react_1.default.createElement("a", { href: 'https://www.mongodb.com/', target: '_blank' }, "mongoDB."))),
            react_1.default.createElement("div", { className: 'backend-card' },
                react_1.default.createElement("span", null),
                react_1.default.createElement("h1", { style: { textAlign: 'center', marginTop: 43 } }, "My-stack"))));
    };
    return SkillsBar;
}(react_1.Component));
exports.SkillsBar = SkillsBar;



//////////////////
// WEBPACK FOOTER
// ./src/App/components/Skills/components/SkillBar/SkillsBar.tsx
// module id = 72
// module chunks = 0